import { render } from "./HiIFrame.vue?vue&type=template&id=a7b1ef62"
import script from "./HiIFrame.vue?vue&type=script&lang=js"
export * from "./HiIFrame.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__